<template>
    <ui-modal-message-v2
        name="progress-bar-modal"
        service="user"
        :cancelButton="false"
        :closeButton="handleCloseButton"
        :color-square="colorSquareHandle"
        icon-square
        :dynamicIcon="icon"
        :widthDynamicIcon="24"
        :heightDynamicIcon="16"
        @modal-closed="handleModalClosed"
    >
        <template #title >
            <div v-if="!handleError && !isSuccessfull">
                {{ titleProgressModal }}
            </div>
            <div v-if="!handleError && isSuccessfull">
                {{ titleSuccess }} <span class="success-title">realizado com sucesso!</span>
            </div>
        </template>
        <template #text>
            <div class="text-container">
                <div v-if="!handleError" class="progress-bar-container">
                    <div class="progress-bar">
                        <div 
                            class="progress" 
                            :style="{ width: progressPercentage + '%', backgroundColor: isPausedComputed ? '#AAB2CF' : '#1CCA85' }"
                        ></div>
                    </div>
                </div>
                <div v-if="handleError && !isSuccessfull">
                    Um erro inesperado ocorreu. Tente novamente.
                </div>
                <div v-if="!handleError && !isSuccessfull" class="text-alert">
                    {{ modalAlert }}
                </div>
            </div>
        </template>
        <template #footer>
            <div class="footer-container" :class="{'footer-container-success' : isSuccessfull}">
                <div v-if="!isPaused && !handleError && !isSuccessfull" class="inProgressFooter">
                    <ui-load-indicator
                        :h="24"
                        :stroke="8"
                        bg-color="#D9DFF1"
                        color="#0091FF"
                    />
                    <p>Espere alguns segundos, estamos finalizando</p>
                </div>
                <div v-if="isPaused && !handleError && !isSuccessfull" class="pausedFooter">
                    <p>Ação pausada. Feche esse modal para interromper</p>
                </div>
                <div v-if="handleError && !isPaused && !isSuccessfull">
                    <div class="suport-text">
                        <ui-suport-icon/>
                        <p>Se o erro persistir, entre em <span class="support-contact">contato com o suporte.</span></p>
                    </div>
                </div>
                <ui-button v-if="!handleError && !isSuccessfull" :design="buttonDesign" :disabled="blockPauseButton" @click="togglePause">
                    {{ isPausedComputed  ? 'Continuar' : 'Pausar' }}
                </ui-button>
                <ui-button v-if="handleError || isSuccessfull" :design="buttonDesign" :disabled="false" @click="closeButtonHandle">Sair</ui-button>
            </div>
        </template>
    </ui-modal-message-v2>
</template>

<script>
    import { uiButton } from '@/components/ui/buttons'
    import { uiLoadIndicator } from '@/components/ui'
    import { uiModalMessageV2 } from '@/components/ui/modal';

    export default {
        name: 'progress-bar-modal',
        components: {
            uiButton,
            uiModalMessageV2,
            uiLoadIndicator
        },

        props:{
            icon:{
                type: String,
                default: 'ui-allotment-icon',
                required: true
            },
            titleProgressModal:{
                type: String,
                default: '',
                required: false
            },
            titleSuccess:{
                type: String,
                default: '',
                required: false
            },
            modalAlert: {
                type: String,
                default: '',
                required: false
            },
            handleError:{
                type: Boolean,
                default: false,
                required: true
            },
            progressValue: { // Valor atual do progresso
                type: Number,
                required: true 
            },
            totalValue: { // Total de itens a serem processados
                type: Number,
                required: true 
            },
            isPaused: {
                type: Boolean,
                required: true,
                default: false
            },
            isSuccessfull:{
                type: Boolean,
                required: true,
                default: false
            },
            blockPauseButton:{
                type: Boolean,
                required: false,
                default: false
            }
        },

        data(){
            return{
                // isPaused: false,
            }
        },

        mounted() {
            this.$root.$on('open-modal', this.resetModal);
        },

        beforeDestroy() {
            this.$root.$off('close-modal', this.resetModal);
        },

        computed: {
            progressPercentage() {
                return this.totalValue > 0 ? (this.progressValue / this.totalValue) * 100 : 0;
            },  
            currentValue() {
                return this.progressValue;
            }, 
            buttonDesign() {
                return this.isPausedComputed  ? 'md success' : 'md primary';
            },
            colorSquareHandle(){
                if(this.handleError && !this.isPausedComputed){
                    return 'danger'
                }
                else if(!this.handleError && this.isPausedComputed){
                    return 'stoped'
                }
                else {
                   return 'primary'
                }
            },
            handleCloseButton() {
                return !!this.isPausedComputed;
            },
            isPausedComputed: {
                get() {
                    return this.isPaused;
                },
                set(value) {
                    this.$emit('update:isPaused', value);
                }
            }
        },

        watch: {
            
        },

        methods: {
            togglePause() {
                this.isPausedComputed = !this.isPausedComputed;
                this.$emit('update:isPaused', !this.isPaused);
            },
            resetModal() {
                this.isPausedComputed = false; 
                this.$emit('update:isPaused', false);
            },
            handleModalClosed() {
                // Emite um evento para a VIEW PAI escutar e reagir
                this.$emit("modal-closed-parent");
            },
            closeButtonHandle(){
                this.$root.$emit("modal-msg-close-progress-bar-modal");
            }

        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>